import { Theme, Paper, IconButton, Grid, Alert } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import { taxSlice } from "../../../store/reducer/tax";
import FileUploadIcon from "../../../assets/file_upload_icon.svg";
import EditIcon from "@mui/icons-material/Edit";
import { TaxDocument } from "../../../model/tax/tax_document";
import { IRSScheduleCForm } from "../../../model/tax/irsschedulec";
import { toDollar, toFloatString, toFloatStringAllowingNegative } from "../../../utils/dataConverter";
import { MaskTypes } from "../../../utils/models";
import MaskTextInput from "../../../components/MaskTextInput";
import InfoRounded from "@mui/icons-material/InfoRounded";
import { ValidatorForm } from "react-material-ui-form-validator";

interface ConfirmScheduleCProps {
  deleteFile: (index: number) => void;
  index: number;
  schC: TaxDocument<IRSScheduleCForm>;
  editMode: boolean | undefined;
  toggleEditMode: (value: boolean) => void;
}
const ConfirmScheduleC = ({
  deleteFile,
  index,
  schC,
  editMode,
  toggleEditMode,
}: ConfirmScheduleCProps) => {
  const dispatch = useDispatch();
  const [showFieldErrors, setShowFieldErrors] = useState(false);

  const updateScheduleCValues = () => {
    if (
      Object.values({ ...schC.form_data, user_id: 1 }).some(
        (value) => value === null || value === ""
      )
    ) {
      setShowFieldErrors(true);
      return;
    }
    //toggleEditMode(false);
  };

  useEffect(() => {
    if (editMode === undefined) {
      toggleEditMode(true);
    }
  }, [editMode, toggleEditMode]);

  return (
    <div className="file-info">
      <Paper elevation={0} className={"file-wrapper"}>
        {(schC.warnings ?? {}).uploaded_document?.map((warning: string) => (
          <Alert
            severity="error"
            variant="outlined"
            classes={{
              root: "error-alert",
              message: "success-msg",
              icon: "error-icon",
            }}
            iconMapping={{ error: <InfoRounded /> }}
          >
            {warning}
          </Alert>
        ))}
        <div className={"uploaded-file-container"}>
          <p className={"file-name-wrapper"}>
            <img
              src={FileUploadIcon}
              alt={"File upload icon"}
              className="file-img"
            />
            {schC.uploaded_file.file_name}
          </p>
          <div className="review-link">
            {!editMode ? (
              <IconButton
                className="edit-btn"
                onClick={() => toggleEditMode(true)}
                size="large"
              >
                <EditIcon className="edit-icon" />
              </IconButton>
            ) : (
              <button className="delete-link" onClick={() => deleteFile(index)}>
                delete
              </button>
            )}
          </div>
        </div>
        <div className="file-title-header">
          <h3>Profit or Loss from Business</h3>
          <div className="spacer"></div>
          <button className={"delete-link"} onClick={() => deleteFile(index)}>
            delete
          </button>
        </div>
        {editMode ? (
          <ValidatorForm onSubmit={() => {}}>
            <Grid className={"form-row"} size={12}>
              <MaskTextInput
                name="net_profit_or_loss"
                variant="outlined"
                label="Net profit or loss from line 31 of Schedule C"
                placeholder="Net profit or loss"
                className="text-field"
                value={schC.form_data.net_profit_or_loss}
                error={
                  showFieldErrors && !schC.form_data.net_profit_or_loss
                }
                helperText={showFieldErrors && !schC.form_data.net_profit_or_loss ? "Must not be empty" : null}
                maskType={MaskTypes.Dollar}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  dispatch(
                    taxSlice.actions.updateScheduleCValueChange({
                      key: "net_profit_or_loss",
                      value: toFloatStringAllowingNegative(e.target.value),
                      index: index,
                    })
                  );
                  updateScheduleCValues();
                }}
              />
            </Grid>
          </ValidatorForm>
        ) : (
          <>
            <div className="form-static">
              <label className="form-static-title">Net Profit or Loss</label>
              <label key={"employer_name"} className="form-static-value">
                {toDollar(schC.form_data.net_profit_or_loss)}
              </label>
            </div>
          </>
        )}
      </Paper>
    </div>
  );
};

export default ConfirmScheduleC;
